<template>
  <div class="px-4">
    <h1>Webseite onboarden</h1>

    <mia-wait for="fetching domains">
      <template #waiting>
        <div class="flex justify-center">
          <mia-wave-loader />
        </div>
      </template>

      <datatable
        :columns="columns"
        :data="domains"
        class="sticky w-full mt-4 table-auto datatable"
      />
    </mia-wait>
  </div>
</template>

<script>
import Vue from 'vue'
import { getDomains } from '@/api/websiteOnboarding'
import DatatableCertificateColumn from '@/components/website/onboarding/DatatableCertificateColumn.vue'
import DatatableCloudfrontColumn from '@/components/website/onboarding/DatatableCloudfrontColumn.vue'
import DatatableCloudfrontAliasColumn from '@/components/website/onboarding/DatatableCloudfrontAliasColumn.vue'

Vue.component('mia-website-onboarding-datatable-certificate-column', DatatableCertificateColumn)
Vue.component('mia-website-onboarding-datatable-cloudfront-column', DatatableCloudfrontColumn)
Vue.component('mia-website-onboarding-datatable-cloudfront-alias-column', DatatableCloudfrontAliasColumn)

export default {
  name: 'MiaWebsiteOnboarding',

  data() {
    return {
      domains: [],
      columns: [
        {
          label: 'Domain',
          field: 'DomainName',
          headerAlign: 'left'
        },
        {
          label: 'Ablaufdatum',
          field: 'Expiry',
          headerAlign: 'left',
          representedAs: ({ Expiry }) => new Date(Expiry).toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' })
        },
        {
          label: 'Zertifikat',
          headerAlign: 'left',
          component: 'mia-website-onboarding-datatable-certificate-column'
        },
        {
          label: 'Cloudfront',
          headerAlign: 'left',
          component: 'mia-website-onboarding-datatable-cloudfront-column'
        },
        {
          label: 'Cloudfront Alias',
          headerAlign: 'left',
          component: 'mia-website-onboarding-datatable-cloudfront-alias-column'
        }
      ]
    }
  },

  async created() {
    this.$wait.start('fetching domains')

    this.domains = await getDomains()

    this.$wait.end('fetching domains')
  },

  mounted() {
    eventBus.$emit('mia-set-breadcrumb', [
      {
        link: {
          path: '/website'
        },
        text: 'Websitebaukasten'
      },
      {
        link: {
          path: '/website/onboarding'
        },
        text: 'Onboarding'
      }
    ])
  }
}
</script>
